import { makeStyles } from '@material-ui/core/styles'

import colors from '../../../../assets/colors'

const useStyles = makeStyles(() => ({
  subTitle: {
    padding: '8px 0',
    borderTop: '1px dashed',
    borderColor: colors.textSecondary,
    borderBottom: '1px dashed',
    borderBottomColor: colors.textSecondary,
    color: colors.textPrimary,
    fontSize: '14px',
  },
  nfseError: {
    padding: '0 4px',

    borderTop: '1px dashed',
    borderColor: colors.textSecondary,
    borderBottom: '1px dashed',
    borderRadius: '8px',
    borderBottomColor: colors.textSecondary,
    color: colors.textPrimary,
    fontSize: '14px',

    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: colors.bgError,
    opacity: 0.7,
    transition: 'all .4s ease-in-out',
  },
}))

export default useStyles
